import { Button } from "@/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog";
import { Eraser } from "lucide-react";

type ClearCellsDialogProps = {
  open: boolean;
  /** The selected cells that have a value: the cells that Clear empties. */
  count: number;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ClearCellsDialog = ({ open, count, onCancel, onConfirm }: ClearCellsDialogProps) => {
  const cells = count === 1 ? "cell" : "cells";
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onCancel();
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            Clear {count.toLocaleString("en-US")} {cells}?
          </DialogTitle>
          <DialogDescription>
            {count === 1 ? "Its value is" : "Their values are"} deleted. Only a restore of a saved
            checkpoint brings {count === 1 ? "it" : "them"} back.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            <Eraser className="h-4 w-4" aria-hidden />
            Clear {cells}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
